<template>
    <div>
        <GenericCrud
            route-name="SettingsPersonalDataCategories"
            route-action="list"
            :navbar-title="$t('settings.personalDataCategory.buttonLabel')"
            :navbar-back-route-without-history="{ name: 'Settings' }"
            :main-list-filter-label="$t('settings.personalDataCategory.filterLabel')"
            main-fist-scroll-to-selected
            :storeData="{
                mainListItems: {
                    action: 'personalDataCategories/fetch',
                    itemsProperty: 'items',
                    payload: { force: true },
                    options: null,
                    itemText: 'title'
                },
                mainItemById: {
                    action: 'personalDataCategories/fetchById',
                    payload: null,
                    options: null,
                },
                edit: {
                    action: 'personalDataCategories/edit',
                    payload: null,
                    options: null,
                    refetch: true,
                    hideButton: true
                },
                add: {
                    action: 'personalDataCategories/create',
                    payload: null,
                    options: null,
                },
                delete: {
                    action: 'personalDataCategories/delete',
                    payload: null,
                    options: null,
                    hideButton: true
                },
                findUsage: {
                    action: 'personalDataCategories/findUsage',
                    payload: null,
                    options: null,
                    hideButton: true
                },
                replace: {
                    action: 'personalDataCategories/replaceItemInRecord',
                    options: null,
                    hideButton: true
                },
            }"
            :newItemModelFields="{
                clientId: null,
                locale: currentLanguage,
                translations: defaultTranslations,
                personalData: [],
            }"
        >
            <template v-slot:editorMask="x">
                <EditorMask
                    v-model="x.selectedMainItem"
                    :personalDataItems="personalDataItems"
                    :key="x.id"
                    :available-languages="availableLanguages"
                    :current-language="currentLanguage"
                    :isWaiting="x.isWaiting"
                    :isModified="x.isModified"
                    @modified="x.onSetModified"
                    @onSaveItem="x.onSaveItem"
                    @onDeleteItem="x.onDeleteItem"
                    @onFindUsage="x.onFindUsage"
                    @onCreateItem="x.onCreateItem"
                />
            </template>
        </GenericCrud>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import GenericCrud from '@/components/generic/GenericCrud.vue';
import EditorMask from './EditorMask.vue';

export default {
    name: 'SettingspersonalDataCategoriesIndex',
    components: {
        GenericCrud,
        EditorMask,
    },
    i18n: {
        messages: {
            en: require('@/locales/Settings/en.json'),
            de: require('@/locales/Settings/de.json'),
        },
    },
    computed: {
        ...mapGetters({
            personalDataItems: 'personalData/getItems',
            availableLanguages: 'languageSettings/getAvailableLanguages',
            currentLanguage: 'languageSettings/getCurrentLanguage',
        }),
        defaultTranslations() {
            let translations = this.availableLanguages.map(x => {
                return { title: '', locale: x};
            });
            
            return translations.sort((a, b) => {
                return (b.locale === this.currentLanguage && a.locale !== this.currentLanguage) ? 1 : -1;
            });
        }
    },
    methods: {
        ...mapActions({
            fetchPersonalDataItems: 'personalData/fetch',
        }),
        async fetchData() {
            this.$wait.start('pageLoader');
            await Promise.all([this.fetchPersonalDataItems()]);
            this.$wait.end('pageLoader');
        },
    },
    created() {
        this.fetchData();
    },
};
</script>
